import { joinCards } from "../../data/mock";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { Mail } from "lucide-react";

export const JoinExperience = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="join" ref={ref} className="py-24 bg-white">
      <div className={`max-w-7xl mx-auto px-6 lg:px-8 transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}>
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#C8A951] text-sm font-semibold tracking-[0.15em] uppercase mb-4 block">
            Get Involved
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight mb-4">
            Get Involved
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            Multiple ways to engage. Whether you want to learn, lead, showcase, or partner —
            reach out and we'll find the right fit for you.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {joinCards.map((card) => (
            <div
              key={card.id}
              className="relative rounded-2xl overflow-hidden h-[420px] flex flex-col"
            >
              {/* Background Image */}
              <img
                src={card.image}
                alt={card.title}
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] via-[#0F172A]/60 to-[#0F172A]/20" />

              {/* Content */}
              <div className="relative flex-1 flex flex-col justify-end p-6">
                <h3 className="text-xl font-bold text-white mb-1">{card.title}</h3>
                <p className="text-sm text-[#C8A951] font-medium mb-3">{card.subtitle}</p>
                <p className="text-sm text-[#CBD5E1] leading-relaxed mb-5">
                  {card.description}
                </p>

                {/* CTA — the way to join */}
                <a
                  href="mailto:support@iq-hub.com"
                  className="inline-flex items-center gap-2 bg-[#C8A951] hover:bg-[#B8993F] text-[#0F172A] font-semibold text-sm px-5 py-2.5 rounded-lg w-fit transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  Get in Touch
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
